
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTextareaField as ObcTextareaFieldElement} from '@oicl/openbridge-webcomponents/dist/components/textarea-field/textarea-field.js';
 import {VoiceActionDetail} from '@oicl/openbridge-webcomponents/dist/components/textarea-field/textarea-field.js';
 export type {VoiceActionDetail} from '@oicl/openbridge-webcomponents/dist/components/textarea-field/textarea-field.js';
 

 
 export const ObcTextareaField = createComponent({
   react: React,
   tagName: 'obc-textarea-field',
   elementClass: ObcTextareaFieldElement,
   events: {
     
     onChange: 'change' as EventName<CustomEvent<{value: string}>>,
     onInput: 'input' as EventName<CustomEvent<{value: string}>>,
     onBlur: 'blur' as EventName<CustomEvent<void>>,
     onSendClick: 'send-click' as EventName<CustomEvent<{value: string}>>,
     onAddClick: 'add-click' as EventName<CustomEvent<void>>,
     onScreenshotClick: 'screenshot-click' as EventName<CustomEvent<void>>,
     onImageClick: 'image-click' as EventName<CustomEvent<void>>,
     onAttachmentClick: 'attachment-click' as EventName<CustomEvent<void>>,
     onVoiceAction: 'voice-action' as EventName<CustomEvent<VoiceActionDetail>>,
     onAttachmentRemove: 'attachment-remove' as EventName<CustomEvent<{id: string}>>,
   }
  });
 
 